import React from 'react';
import { hot } from 'react-hot-loader';
import { origin } from '../../config';
import { purifier } from '../../utils/dom';

const BreadcrumbsSD = ({ list }) => {
	const jsonData = {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: list.map((item, i) => ({
			'@type': 'ListItem',
			position: i + 1,
			item: {
				'@id': `${origin}${item.uri}`,
				name: item.name,
			},
		})),
	};

	return (
		<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: purifier(JSON.stringify(jsonData), { ALLOWED_TAGS: [] }) }} />
	);
};

export default hot(module)(BreadcrumbsSD);
